import { computed } from 'vue';
import { useKeepAliveStore } from '@shared/store';

// 加载 keepAlive 组件
export const useKeepAliveComponents = () => {
  const keepAliveStore = useKeepAliveStore();
  const keepAliveComponents = computed(() => keepAliveStore.list);
  return {
    keepAliveComponents,
  };
};
